import React from 'react';
import { ListHeader, ListPageLayout, ListWithInfiniteScroll as List } from 'framework/list';
import useProjectsDashboardService from 'domain/sales/projectsDashboard/useProjectsDashboardService';
import ProjectsDashboardsDataGrid from 'domain/sales/projectsDashboard/List/ProjectsDashboardDataGrid';

const ProjectsDashboardsListPage = () => {
  const { search } = useProjectsDashboardService();

  return (
    <List getDataMethod={search}>
      <ListPageLayout header={<ListHeader label="Projects dashboard" />}>
        <ProjectsDashboardsDataGrid />
      </ListPageLayout>
    </List>
  );
};

export default ProjectsDashboardsListPage;
